module.exports = __webpack_public_path__ + "src/routes/report/banner.png?2b617fc5";


//////////////////
// WEBPACK FOOTER
// ./src/routes/report/banner.png
// module id = 918
// module chunks = 1